import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { GLOSSARY_ITEMS, PDF_FONT_SIZE } from './constants';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  title: {
    fontSize: PDF_FONT_SIZE.TITLE,
    marginBottom: 10,
    fontWeight: 'bold',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  column: {
    width: '23%',
  },
  item: {
    marginBottom: 8,
    fontSize: PDF_FONT_SIZE.TITLE,
  },
  label: {
    fontWeight: 'bold',
  },
});

// PDF Document component
const GlosaryAbreviationsPDF = () => {
  // Divide items into 4 approximately equal columns
  const itemsPerColumn = Math.ceil(GLOSSARY_ITEMS.length / 4);
  
  return (
    <View>
      <Text style={styles.title}>Glosario de Abreviaciones</Text>

      <View style={styles.container}>
        {[0, 1, 2, 3].map(columnIndex => (
          <View key={`column-${columnIndex}`} style={styles.column}>
            {GLOSSARY_ITEMS.slice(
              columnIndex * itemsPerColumn, 
              (columnIndex + 1) * itemsPerColumn
            ).map((item, index) => (
              <Text key={`item-${columnIndex}-${index}`} style={styles.item}>
                <Text style={styles.label}>{item.short}: </Text>
                {item.label}
              </Text>
            ))}
          </View>
        ))}
      </View>
    </View>
  );
};

export default GlosaryAbreviationsPDF;
